import { IconKey,IconBusinessplan } from '@tabler/icons';

// constant
const icons = {
    IconKey,
    IconBusinessplan
};
//

const Revenue_Assurance = {

    id: 'Revenue_Assurance',
    title: 'Revenue and Assurance',
    type: 'group',
    display_id:'Q',
    icon: icons.IconBusinessplan,
    children: [
        {
            id: 'code_activation_revenue',
            title: 'Code Activation',
            type: 'item',
            display_id:51,
            url: '/Department/Sales/code_activation',
            breadcrumbs: false
        },
        {
            id: 'csp_network_revenue',
            title: 'CSP Network',
            type: 'item',
            display_id:71,
            url: '/Department/Sales/csp_network',
            breadcrumbs: false
        },
        {
            id: 'mandate_revenue',
            title: 'Mandate',
            type: 'item',
            display_id:72,
            url: '/Department/Sales/mandate',
            breadcrumbs: false
        },
        {
            id: 'csp_activity_revenue',
            title: 'CSP Activity',
            type: 'item',
            display_id:73,
            url: '/Department/Sales/csp_activity',
            breadcrumbs: false
        },
        {
            id: 'transaction_report_revenue',
            title: 'Transaction Report',
            type: 'item',
            display_id:74,
            url: '/Department/Sales/transaction_report',
            breadcrumbs: false
        },
    ]
}

export default Revenue_Assurance;